const KEYBOARD_FOCUSED = 'has--keyboard-focus';

class KeyboardFocus {

    constructor() {
        this.keyDown = false;

        document.addEventListener('keydown', () => this.handleKey(true), {passive: true});
        document.addEventListener('keyup', () => this.handleKey(false), {passive: true});
        document.addEventListener('mouseleave', () => this.handleKey(false), {passive: true});
        document.addEventListener('focus', () => this.handleFocus(), {passive: true});
        document.addEventListener('blur', () => this.handleBlur(), {passive: true});
    }

    handleKey(pressed) {
        this.keyDown = pressed;
    }

    handleFocus() {
        if(this.keyDown) document.documentElement.classList.add(KEYBOARD_FOCUSED);
    }

    handleBlur() {
        document.documentElement.classList.remove(KEYBOARD_FOCUSED);
    }

}

export default new KeyboardFocus();